<script>
import { layoutMethods } from "@/state/helpers";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { reportsMethods, reportsComputed, exportMethods, digitalLoadMethods, digitalLoadComputed,erpFixMessages } from "@/state/helpers"
import Swal from 'sweetalert2';
import moment from 'moment';


/**
 * E-Load list component
 */
export default {
  page: {
    title: "E-Load"
  },
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      filter: null,
      filterOn: [],
      sortBy: "value",
      sortDesc: false,
      fields: [
        {
          key: "transactionId",
          sortable: true,
        },
        {
          key: "promoCode",
          sortable: true,
        },
        {
          key: "name",
          sortable: true,
        },
        {
          key: "transactionStatus",
          sortable: true,
        },
        {
          key: "service",
          sortable: false,
        },
        {
          key: "providerName",
          label: "Provider",
          sortable: false,
        },
        {
          key: "network",
          sortable: true,
        },
        {
          key: "epin",
          sortable: true,
        },
        {
          key: "transactionAmount",
          label:"Load out sales by Users",
          sortable: true,
          thClass: "text-end",
        },
        {
          key: "costAmount",
          sortable: true,
          thClass: "text-end",
        },
        {
          key: "margin",
          sortable: true,
          thClass: "text-end",
        },
        {
          key: "requestTimeStamp",
          label: "Request Date",
          sortable: true,
        },
        {
          key: "rrn",
          label: "RRN",
          sortable: true,
        },
        {
          key: "provider_trade_discount",
          label: "Network provider trade discount",
          sortable: true,
        },
        {
          key: "provider_rebate",
          label: "Network provider rebate",
          sortable: true,
        },
        {
          key: "cm1_margin",
          label: "CM1/Margin",
          sortable: true,
        },
      ],
      view: {
        id: 0,
        userId: 0,
        transactionId: "",
        costAmount: 0,
        transactionAmount: 0,
        margin: 0,
        customerInfo: {
          userId: 0,
          businessId: 0,
          name: "",
          businessName: "",
          mobile: "",
          email: null,
          address: ""
        }
      },
      statusList: [
        { text: "All", value: null },
        { text: "Pending", value: "pending" },
        { text: "Failed", value: "failed" },
        { text: "Success", value: "success" },
      ],
      coinvalue: "",
      statusValue: "",
      typeValue: null,
      datepickervalue: "",
      showModal: false,
      submitted: false,

      selected: null,
      options: [
        { value: "A", text: "TM (from options prop)" },
        { value: "B", text: "Globe (from options prop)" },
      ],

      searchValue: {
        searchField: null,
        search: null,
        status: null,
        dateRange: null,
        sort: 'id',
        orderDesc: true,
        network: null,
        service:null,
        provider:null
      },
      searchList: [
        { text: "Search All", value: null },
        //{ text: "Status", value: "status" },
        { text: "Merchant Name", value: "name" },
        { text: "Promo", value: "promo" },
        { text: "Transaction ID", value: "transaction_id" },
      ],
      walleTypes: [
        { text: 'Please select an option', value: null },
        { text: "ELoad", value: "eload" },
        { text: "Mobile Legend Diamond", value: "Mobile Legend Diamond" },
        { text: "Bills Payment", value: "Bills Payment" }
      ],
      actionIndex: -1,

      rangeOptions: {
        mode: "range",
      },

      exportFilters: {
        wallet: "",
        payment_method: [],
        date_range: null,
      },
      paymentOptions: [
        { text: 'Card', value: "card" },
        { text: "Gcash", value: "gcash" }
      ],
      selectedPaymentOption: [],
      isRange: null,
      rangeOption: {
        mode: "range",
      },
      networkList:[{ text: "All", value: null }],
      serviceList: [{ text: "All", value: null }],
      providerList: [{ text: "All", value: null }]
    };
    
  },
  components: {
    flatPickr
  },
  computed: {
    ...erpFixMessages,
    ...reportsComputed,
    ...digitalLoadComputed
  },
  mounted() {
    this.changeTitle({title: 'Sell Eload Logs'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'} },
        { text: 'Report', to: { name: 'Report'}},
        { text: 'Eload Transactions', to: { name: 'Eload Transaction'}},
      ]
    });
    this.getLogs();
    this.getNetworkList();
    this.actionNetwork({
        action: "services",
        body: {}
    })
    .then((res) => {
      for(let c of res.rows){
        this.serviceList.push({text:c["name"], value:c["id"]})
      }
    }).catch((e)=>{
      console.log("error while setup of service option",e);
    });
    this.actionNetwork({
        action: "providers",
        body: {}
    })
    .then((res) => {
      for(let c of res.rows){
        this.providerList.push({text:c["name"], value:c["id"]})
      }
    }).catch((e)=>{
      console.log("error while setup of provider option",e);
    });
  },
  methods: {
    ...layoutMethods,
    ...reportsMethods,
    ...exportMethods,
    ...digitalLoadMethods,
   async onExport(){
      //await this.onPageUpdate();
      if(this.eloadLogsTotalRows ==0){
        Swal.fire("Failed!", this.exportNullPrompt, "warning");
        return;
      }
      let params = Object.assign(
        this.searchValue,
        {
          module: 'eload_sell',
          email: JSON.parse(localStorage.getItem('userData')).email
        });

      delete params.page;
      delete params.rows;
      
      this.exportReport(params)
        .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
        .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
    },
    async getLogs() {
      var date_to = moment().format('YYYY-MM-DD');
      //var date_from = moment().subtract(1, 'months').format('YYYY-MM-DD');
      var date_range = date_to + ' to ' + date_to;
      this.searchValue.dateRange = date_range
      await this.getEloadLogs({
        page: this.currentPage,
        rows: this.perPage,
        search: '',
        searchField: 'name',
        dateRange: date_range
      });
    },
    getNetworkList() {
      var self = this;
      this.getEloadNetworkListAll({rows:9999, sort:'name',orderDesc:false})
      .then(function(){
          for(let data of self.loadNetworkListAll){
            self.networkList.push({ 'text': data.name, 'value': data.name })
          }
      })
    },
    async searchLog() {
      await this.getEloadLogs({
        page: this.currentPage,
        rows: this.perPage,
        ...this.searchValue
      })
    },
    onTableSort(params)
    {
      this.searchValue.sort = params.sortBy;
      this.searchValue.orderDesc = params.sortDesc;
      console.log(this.searchValue);
      this.getEloadLogs({
        page: this.currentPage,
        rows: this.perPage,
        ...this.searchValue
      });
    },
    async onPageUpdate(reset = false) {
      if(this.searching || this.searchValue.status != null || this.searchValue.dateRange != null || this.searchValue.sort != null) {
        this.currentPage = (reset ? 1 : this.currentPage);
        await this.searchLog()
      } else {
        await this.getLogs()
      }
    },
    async onSearch(page) {
      this.currentPage = (page == null) ? 1 : page;
      if (this.searchValue.search) {
        this.searching = true
        await this.searchLog()
      } else {
        this.searching = false
        this.searchValue = {
          search: null,
          searchField: null,
        }
        await this.getLogs()
      }
    },
    formatDate(value){
      return moment(value).format('LLL');
    },
    getStatusClassColor(data) {
      return data === 'FAILED' ? 'text-danger fw-medium m-0' : data === 'SUCCESS' ? 'text-success fw-medium m-0' : 'text-warning fw-medium m-0'; 
    },
    getStatusClassColorTrans(data) {
      return data === 'FAILED' ? 'text-danger' : data === 'SUCCESS' ? 'text-success' : 'text-warning'; 
    },
    infoModalFunction(data) {
      this.view = data
      this.$router.push({ path: `eload-transaction/${data.transactionId}` });
      // console.log(JSON.stringify(this.view))
    },
    exportLogs() {
      /*this.$bvModal.hide("bv-modal-export")
      let dates = this.exportFilters.date_range.split(' to '),
          start_date = dates[0],
          end_date = dates[1]*/

      const user_email = JSON.parse(localStorage.getItem('userData')).email
      /*let filters = {
        ...this.exportFilters,
        date_start: start_date,
        date_end:end_date
      }*/
      this.exportEloadLogs({
        //filters: filters,
        emailAddress: user_email
      }).then((response) => {
        console.log("EXport: ", response);
        Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success");

        return;
      })
      .catch(function (error) {
        console.log(error);
        return;
      });
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <h5 class="card-title">
                    <span class="text-muted fw-normal ms-2">({{eloadLogsTotalRows}})</span>
                    Record(s)
                  </h5>
                </div>
              </div>
              <!-- end col -->

              <!-- end col -->
              <div class="col-md-6" style="text-align: right;">
                <a
                  href="javascript:void(0);"
                  class="btn btn-primary me-2"
                  data-bs-toggle="modal"
                  @click="onExport"
                >
                  <i class="uil uil-export me-1"></i>
                  Export
                </a>
                <button class="btn btn-secondary" @click="onPageUpdate()">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; Refresh
                </button>
              </div>
              <!-- Search and button -->
              <div class="row mt-3 mb-2 px-3">
                <div class="col-md-4 ta-right">
                  <b-form-group description="Search Keyword">
                    <form class="d-flex" @submit.prevent="onSearch()">
                      <b-form-group id="input-group-3" label-for="input-3">
                        <b-form-select
                          class="form-select rounded-0 rounded-start shadow-none"
                          style="width: fit-content"
                          id="input-3"
                          v-model="searchValue.searchField"
                          :options="searchList"
                        ></b-form-select>
                      </b-form-group>

                      <b-input-group>
                        <b-form-input
                          class="rounded-0"
                          v-model="searchValue.search"
                        ></b-form-input>
                        <b-input-group-append  v-if="false">
                          <b-button
                            variant="primary"
                            type="submit"
                            class="rounded-0 rounded-end px-2"
                          >
                            <i class="bx bx-search bx-fw"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </form>
                  </b-form-group>
                </div>
                <div class="col-md-8">
                  <div
                    class="
                      d-flex
                      flex-wrap
                      align-items-start
                      mt-2 mt-md-0
                      gap-2
                      mb-3 ta-right
                    "
                  >
                    <b-form-group label-for="status" description="Filter by status">
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:fit-content"
                        v-model="searchValue.status"
                        :options="statusList"
                      ></b-form-select>
                    </b-form-group>

                    <b-form-group label-for="service" description="Filter by service">
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:fit-content"
                        v-model="searchValue.service"
                        :options="serviceList"
                      ></b-form-select>
                    </b-form-group>

                    <b-form-group label-for="service" description="Filter by provider">
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:fit-content"
                        v-model="searchValue.provider"
                        :options="providerList"
                      ></b-form-select>
                    </b-form-group>

                    <b-form-group label-for="network" description="Filter by network">
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="max-width: 150px;"
                        v-model="searchValue.network"
                        :options="networkList"
                      ></b-form-select>
                    </b-form-group>
                        
                    <b-form-group description="Filter by Request Date">
                      <flat-pickr
                        v-model="searchValue.dateRange"
                        :config="rangeOption"
                        placeholder="Select a date range"
                        class="form-control"
                        style="width: fit-content"
                      ></flat-pickr>
                    </b-form-group>
                    <a class="btn btn-primary h-fit" @click="onPageUpdate(true)">
                      <i class='bx bx-search bx-fw'></i>Search
                    </a>
                  </div>
                </div>
              </div>
            </div>
        
            <!-- end row -->

            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :items="eloadLogs"
                  :fields="fields"
                  responsive="sm"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="onTableSort"
                  class="table-check"
                >
                  <template #cell(transactionId)="data">
                    <b-link
                      class="fw-medium"
                      @click="
                        infoModalFunction(data.item);
                      "
                      >{{ data.item.transactionId }}
                    </b-link>
                  </template>
                  

                  <template #cell(name)="data">
                    <span class="text-body fw-medium m-0">{{
                      data.item.customerInfo.name
                    }}</span>
                  </template>

                  <template #cell(transactionStatus)="data">
                    <span :class="getStatusClassColor(data.item.transactionStatus)">{{
                      data.item.transactionStatus
                    }}</span>
                  </template>

                  <template #cell(service)="data">
                    <span class="text-body fw-medium m-0">{{
                      data.item.service
                    }}</span>
                  </template>

                  <template #cell(network)="data">
                    <span class="text-body fw-medium m-0">{{
                      data.item.network
                    }}</span>
                  </template>

                  <template #cell(epin)="data">
                    <span class="text-body fw-medium m-0">{{
                      data.item.epin
                    }}</span>
                  </template>
                  
                  <template #cell(transactionAmount)="data">
                    <p class="text-body text-end m-0">
                      PHP {{ data.item.transactionAmount | toCurrency }}
                    </p>
                  </template>

                  <template #cell(costAmount)="data">
                    <p class="text-body text-end m-0">
                      PHP {{ data.item.costAmount | toCurrency }}
                    </p>
                  </template>
                  <template #cell(margin)="data">
                    <p class="text-body text-end m-0">
                      PHP {{ data.item.margin | toCurrency }}
                    </p>
                  </template>
                  <template #cell(requestTimeStamp)="data">
                    <p class="text-body m-0">
                      {{ formatDate(data.item.requestTimeStamp) }}
                    </p>
                  </template>
                  <template #cell(provider_trade_discount)="data">
                    <p class="text-body text-end m-0">
                      PHP {{ data.item.provider_trade_discount == null ? 0:data.item.provider_trade_discount | toCurrency }}
                    </p>
                  </template>
                  <template #cell(provider_rebate)="data">
                    <p class="text-body text-end m-0">
                      PHP {{ data.item.provider_rebate == null ? 0:data.item.provider_rebate | toCurrency }}
                    </p>
                  </template>
                  <template #cell(cm1_margin)="data">
                    <p class="text-body text-end m-0">
                      PHP {{ data.item.cm1_margin == null ? 0:data.item.cm1_margin | toCurrency }}
                    </p>
                  </template>
                </b-table>
              </div>
            </div>
            <!-- end table responsive -->
            <div class="row g-0 text-center" v-if="eloadLogsTotalRows == 0">
              <span>No data to display.</span>
            </div>
            <div class="row g-0" v-if="eloadLogsTotalRows != 0 && eloadLogsTotalRows > 10">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="d-flex">
              

                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="perPage"
                            :options="pageOptions"
                            @change="onSearch()"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    
                    <div class="col">
                      <div class="dataTables_paginate paging_simple_numbers float-end">
                        <!-- pagination -->
                        <b-pagination
                          class="pagination-rounded"
                          v-model="currentPage"
                          :total-rows="eloadLogsTotalRows"
                          @input="onPageUpdate()"
                          :per-page="perPage"
                        ></b-pagination>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>

            <!-- disable for the meantime -->
            <b-modal
              id="bv-modal-export"
              centered
              no-close-on-esc
              no-close-on-backdrop
            >
              <template v-slot:modal-header>
                <h4 class="modal-title">
                  <i class="uil uil-export me-1"></i>
                  <b>Export</b>
                </h4>
              </template>
              <form class="px-4 py-3">
                <div class="row">
                  <div class="col-md-4">
                    <b-form-group>
                      <label class="form-label small fw-bold">Wallet Type</label>
                      <b-form-select
                        class="form-select rounded-0 rounded-start shadow-none ml-5"
                        style="width: 250px"
                        id="input-3"
                        v-model="exportFilters.wallet"
                        :options="walleTypes"
                        required
                      ></b-form-select>
                    </b-form-group>
                    <b-form-group>
                      <label class="form-label small fw-bold">Payment Method</label>
                      <b-form-checkbox-group
                        class="ml-75"
                        id="checkbox-group-1"
                        v-model="exportFilters.payment_method"
                        :options="paymentOptions"
                        name="flavour-1"
                      ></b-form-checkbox-group>
                    </b-form-group>
                    <div class="mb-3">
                      <label class="form-label">Range</label>
                      <flat-pickr
                        v-model="exportFilters.date_range"
                        :config="rangeOptions"
                        placeholder="Select a date"
                        class="form-control"
                        style="width: 250px"
                      ></flat-pickr>
                    </div>
                  </div>
                </div>
              </form>

              <template v-slot:modal-footer>
                <div class="text-end mt-3">
                  <b-button
                    variant="light"
                    class="w-sm"
                    @click="$bvModal.hide('bv-modal-export')"
                    >Close</b-button
                  >
                  <b-button variant="primary" class="w-sm ms-2" @click="exportLogs()"
                    >Submit</b-button
                  >
                </div>
              </template>
            </b-modal>
            <!-- end row -->
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</template>
